export const emailRegex =
  /^([\w+-]+)(\.[\w+-]+)*@([a-z\d][a-z\d-]*\.)+[a-z]{2,}$/i;
